import axios from 'axios';
import ReactGA from 'react-ga';

export const api = process?.env?.NODE_ENV === 'development' ? 'http://localhost:4000' : 'https://citamex.vercel.app'

export const getSubProfessions = (professionId = 1) => {
    return axios.get(`${api}/sub-professions`)
}
export const getProfessions = (professionId = 1) => {
    return axios.get(`${api}/professions`)
}

export const getSupplierData = (authToken) => {
    return axios.get(`${api}/supplier`, {params: {authToken}})
}

export const getSuppliers = () => {
    return axios.get(`${api}/supplier/all`)
}

export const getPublicSupplierData = (shortHash) => {
    return axios.get(`${api}/supplier/public`, {params: {shortHash}})
}
export const checkSupplierExist = (email) => {
    return axios.get(`${api}/supplier/check-exist`, {params: {email}})
}

export const checkShortHashExist = (shortHash) => {
    return axios.get(`${api}/supplier/check-short-hash-exist`, {params: {shortHash}})
}
export const getBookingSlots = (shortHash,appointmentDuration,customerAddress) => {
    return axios.get(`${api}/booking-slots`, {params: {shortHash, appointmentDuration, customerAddress}})
}

export const registerOrUpdateSupplier = (payload) => {
    ReactGA.event({
        category: "New signup",
        action: "New supplier signup",
    });
    return axios.post(`${api}/supplier`, {payload})
}
export const addSubscription = (payload) => {
    return axios.post(`${api}/supplier/add-subscription`, {payload})
}

export const createAppointment = (payload) => {
    ReactGA.event({
        category: "New appointment",
        action: "New appointment created",
    });
    return axios.post(`${api}/appointment`, {payload})
}
export const editAppointment = (payload) => {
    ReactGA.event({
        category: "Edit appointment",
        action: "appointment edited",
    });
    return axios.put(`${api}/appointment`, {payload})
}

export const createBlockedShift = (payload) => {
    return axios.post(`${api}/blockedTime`, {payload})
}

export const deleteBlockedShift = ({_id, supplierId}) => {
    return axios.delete(`${api}/blockedTime?_id=${_id}&supplierId=${supplierId}`)
}

export const deleteAppointment = ({appointmentId}) => {
    return axios.delete(`${api}/appointment?appointmentId=${appointmentId}`)
}

export const getAddress = ({input})=>{
    const parameters = {
        key:'',
        input,

    }
    return axios.get(`https://maps.googleapis.com/maps/api/geocode/outputFormat?${JSON.stringify(parameters)}`)
}

export const getHereToken = ()=>{
    return axios.get(`${api}/here/getToken`)
}

export const getPaymentPageLink = (payload) => {
    return axios.post(`${api}/payment/getFormLink`, payload)

}

